import { Put, Post, Delete, Get } from "./common";

export default class MediumService {
  static getByCategory = async (data: any) =>
    await Post({ path: "mediums/by-category", body: data });

  static list = async (token: string, data: any) =>
    await Post({ path: "mediums/list", token, body: data });

  static all = async (data: any) =>
    await Post({ path: "mediums/all", body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "mediums", token, body: data });

  static update = async (token: string, id: string, data: any) =>
    await Put({ path: `mediums/${id}`, token, body: data });

  static getById = async (id: string, token: string) =>
    await Get({ path: `mediums/${id}`, token });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `mediums/${id}`, token });
}
